import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {tokenNotExpired} from 'angular2-jwt';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    title = 'app';

    constructor(private router: Router) {
    }

    loggedIn() {
        return tokenNotExpired();
    }

    logout() {
        localStorage.removeItem('token');
        this.router.navigate(['login']);
    }
}



// WEBPACK FOOTER //
// /builds/johannes-jonsson/consmin-app/src/app/app.component.ts